/* EDUARD-CUSTOM
   Sprungziele zuverlaessig anspringen.

   Das Theme fuehrt den nativen Sprung auf eine #Marke nicht aus: weder beim
   Laden einer Adresse mit #, noch beim Klick auf einen Link innerhalb der
   Seite. Gemessen am 05.09.2026 auf der Startseite (Anker faq, about-us) —
   scrollIntoView funktioniert, die Fragment-Navigation nicht.

   Dieses Skript uebernimmt deshalb drei Dinge:
    1. Beim Laden: steht ein # in der Adresse, wird das Ziel angesprungen und
       nach dem Nachladen von Bildern noch einmal nachgefasst.
    2. Beim Klick auf einen Link, der auf derselben Seite landet.
    3. Bei hashchange.

   Dazu zwei Korrekturen an den Menuelinks, beide beim Laden:
    - target="_blank" wird von internen Links mit # entfernt. Das Theme setzt es
      auf jeden Menuepunkt vom Typ "http_link", solange die Theme-Einstellung
      "Open external links in a new tab" (settings.open_new_tab, Standard an)
      aktiv ist — auch bei internen Sprungmarken wie /#faq. Die oeffneten sonst
      einen neuen Tab statt zu scrollen. Betroffen ist nur der Desktop-Header,
      die mobile Schublade rendert ohne target.
    - Links der Form "/#anker" bekommen in der englischen Fassung das
      Sprachpraefix aus window.EDUARD_ROOT (routes.root_url). Shopify uebersetzt
      nur die Beschriftung eines Menuepunkts, nicht seine Adresse. Praktisch
      greift das selten, weil Shopify relative Menue-URLs selbst lokalisiert.

   Die Kategorie-Kaestchen der Produktseite (.ecl) haben ihr eigenes Skript und
   werden hier ausgelassen — zwei gleichzeitige weiche Scrolls heben sich sonst
   gegenseitig auf. */

(function () {
  if (window.__eduardAnchorJump) return;
  window.__eduardAnchorJump = true;

  function targetOf(hash) {
    if (!hash || hash.length < 2) return null;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (e) { id = hash.slice(1); }
    if (!id) return null;
    return document.getElementById(id);
  }

  function offsetOf(el) {
    var v = parseFloat(window.getComputedStyle(el).scrollMarginTop);
    return isNaN(v) ? 0 : v;
  }

  function wantedY(el) {
    var y = window.pageYOffset + el.getBoundingClientRect().top - offsetOf(el);
    return y < 0 ? 0 : y;
  }

  function settle(el, smooth) {
    window.scrollTo({ top: wantedY(el), behavior: smooth ? 'smooth' : 'instant' });

    var moved = false;
    var events = ['wheel', 'touchstart', 'keydown'];
    function onUser() { moved = true; }
    events.forEach(function (t) { window.addEventListener(t, onUser, { passive: true }); });

    window.setTimeout(function () {
      events.forEach(function (t) { window.removeEventListener(t, onUser); });
      if (moved || !document.body.contains(el)) return;
      var y = wantedY(el);
      if (Math.abs(y - window.pageYOffset) > 4) {
        window.scrollTo({ top: y, behavior: 'instant' });
      }
    }, 900);
  }

  /* Interne Links mit # sollen nie einen neuen Tab oeffnen. Externe behalten
     ihr target. */
  function unblankHashLinks() {
    var links = document.querySelectorAll('a[target="_blank"][href*="#"]');
    for (var i = 0; i < links.length; i++) {
      var url;
      try { url = new URL(links[i].href, window.location.href); } catch (e) { continue; }
      if (url.origin === window.location.origin && url.hash.length > 1) {
        links[i].removeAttribute('target');
      }
    }
  }

  /* Sprachpraefix fuer Menuelinks der Form "/#anker" */
  function localizeHashLinks() {
    var root = window.EDUARD_ROOT || '/';
    if (root === '/' || root === '') return;
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    var links = document.querySelectorAll('a[href^="/#"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', root + links[i].getAttribute('href').slice(1));
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download')) return;
    if (a.closest('.ecl')) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var url;
    try { url = new URL(a.href, window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;

    var el = targetOf(url.hash);
    if (!el) return;

    e.preventDefault();
    if (window.location.hash !== url.hash) {
      try { window.history.pushState(null, '', url.hash); } catch (err) {}
    }
    settle(el, true);
  }, true);

  window.addEventListener('hashchange', function () {
    var el = targetOf(window.location.hash);
    if (el) settle(el, true);
  });

  function onReady() {
    unblankHashLinks();
    localizeHashLinks();
    var el = targetOf(window.location.hash);
    if (!el) return;
    settle(el, false);
    window.addEventListener('load', function () {
      var again = targetOf(window.location.hash);
      if (again) settle(again, false);
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();